import { useState, useEffect } from 'react';
import { calculateStateDuration } from 'utils/helpers/dateHelper';
export var useAgentTimer = function (agentStatus) {
    var _a, _b;
    // Extract startTime from currentState (preferred) or agentStateData (fallback)
    var startTime = ((_a = agentStatus === null || agentStatus === void 0 ? void 0 : agentStatus.currentState) === null || _a === void 0 ? void 0 : _a.startTime) || ((_b = agentStatus === null || agentStatus === void 0 ? void 0 : agentStatus.agentStateData) === null || _b === void 0 ? void 0 : _b.StartTime);
    var _c = useState(calculateStateDuration(startTime)), timeDuration = _c[0], setTimeDuration = _c[1];
    useEffect(function () {
        setTimeDuration(calculateStateDuration(startTime));
        var interval = setInterval(function () {
            setTimeDuration(calculateStateDuration(startTime));
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [startTime]);
    return timeDuration;
};
